import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HardHat, Users, ChevronRight } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { WorkforceAuthPage, WorkforceHero } from '../WorkforceTheme';

export default function WorkforceLanding() {
  const navigate = useNavigate();
  return (
    <WorkforceAuthPage>
      <div className="w-full max-w-2xl" data-testid="workforce-landing">
        <WorkforceHero subtitle="Complete your profile, sign required documents, and access your BuildBroz work dashboard." />

        <div className="rounded-2xl border border-[#D4AF37]/25 bg-black/60 backdrop-blur-md p-6 sm:p-8 shadow-[0_0_60px_rgba(212,175,55,0.08)]">
          <div className="flex items-center gap-4 justify-center mb-6">
            <div className="h-px flex-1 max-w-[90px] bg-gradient-to-r from-transparent to-[#D4AF37]/60" />
            <span className="h-10 w-10 rounded-full border border-[#D4AF37]/60 flex items-center justify-center shrink-0">
              <Users size={18} className="text-[#D4AF37]" />
            </span>
            <h2 className="text-white font-brand font-extrabold text-lg md:text-lg">Get Started</h2>
            <div className="h-px flex-1 max-w-[90px] bg-gradient-to-l from-transparent to-[#D4AF37]/60" />
          </div>

          <div className="rounded-xl border border-[#D4AF37]/30 bg-[#0D0D0D]/80 p-6 sm:p-8 text-center max-w-sm mx-auto" data-testid="employee-card">
            <HardHat size={40} className="text-[#D4AF37] mx-auto" strokeWidth={1.5} />
            <h3 className="text-white font-brand font-extrabold text-xl mt-3">Login to Your Workforce</h3>
            <p className="text-gray-400 text-sm mt-2 leading-relaxed">Clock in, track your hours, view your work history, and access weekly pay records.</p>
            <Button onClick={() => navigate('/workforce/login')}
              className="mt-5 w-full bg-gradient-to-b from-[#F0CB5C] to-[#C99E2E] text-black hover:from-[#D4AF37] hover:to-[#B8941F] font-brand font-extrabold py-6 rounded-lg"
              data-testid="continue-as-employee-btn">
              Start Building with BuildBroz <ChevronRight size={16} />
            </Button>
          </div>
        </div>
      </div>
    </WorkforceAuthPage>
  );
}
